import { StreetLines } from './route-types';

export const demoStreetLines: StreetLines = [
  {
    streetName: 'Orange Route',
    routeId: '7003',
    stops: [
      {
        stopCode: 'OS1',
        streetName: 'Orange Route',
        stopName: 'Town Hall',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.2653656',
        stopLon: '103.8216731',
        busTerminal: false,
      },
      {
        stopCode: 'OS2',
        streetName: 'Orange Route',
        stopName: 'Library Lane',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.284154',
        stopLon: '103.843081',
        busTerminal: false,
      },
      {
        stopCode: 'OS3',
        streetName: 'Orange Route',
        stopName: 'Stadium',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.349162',
        stopLon: '103.873010',
        busTerminal: false,
      },
      {
        stopCode: 'OS4',
        streetName: 'Orange Route',
        stopName: 'Docklands Pier',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.3711822747611109',
        stopLon: '103.89246560907316',
        busTerminal: false,
      },
      {
        stopCode: 'OS5',
        streetName: 'Orange Route',
        stopName: 'Manchester Meadows',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.4048144',
        stopLon: '103.902759321',
        busTerminal: false,
      },
    ],
  },
  {
    streetName: 'Green Route',
    routeId: '7002',
    stops: [
      {
        stopCode: 'GS1',
        streetName: 'Green Route',
        stopName: 'Buckingham Blvd',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.3725841',
        stopLon: '103.9480903',
        busTerminal: false,
      },
      {
        stopCode: 'GS2',
        streetName: 'Green Route',
        stopName: 'Stratford',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.3518124',
        stopLon: '103.9437422',
        busTerminal: false,
      },
      {
        stopCode: 'GS3',
        streetName: 'Green Route',
        stopName: 'Windsor Way',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.3237203',
        stopLon: '103.9290162',
        busTerminal: false,
      },
      {
        stopCode: 'GS4',
        streetName: 'Green Route',
        stopName: 'Oxford Overpass',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.3179272',
        stopLon: '103.891838',
        busTerminal: false,
      },
      {
        stopCode: 'GS5',
        streetName: 'Green Route',
        stopName: 'Cambridge Cresent',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.2996007',
        stopLon: '103.8550052',
        busTerminal: false,
      },
      {
        stopCode: 'GS6',
        streetName: 'Green Route',
        stopName: 'York Yard',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.2811824',
        stopLon: '103.8409212',
        busTerminal: false,
      },
      {
        stopCode: 'GS7',
        streetName: 'Green Route',
        stopName: 'Leeds Lane',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.2927635057238263',
        stopLon: '103.78620150994891',
        busTerminal: false,
      },
      {
        stopCode: 'GS8',
        streetName: 'Green Route',
        stopName: 'Cantebury Court',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.315043',
        stopLon: '103.764998',
        busTerminal: false,
      },
      {
        stopCode: 'GS9',
        streetName: 'Green Route',
        stopName: 'Bristol Bridge',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.336771',
        stopLon: '103.705133',
        busTerminal: false,
      },
      {
        stopCode: 'GS10',
        streetName: 'Green Route',
        stopName: 'Liverpool Landing',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.340476',
        stopLon: '103.637113',
        busTerminal: false,
      },
    ],
  },
  {
    streetName: 'Red Route',
    routeId: '7001',
    stops: [
      {
        stopCode: 'RS1',
        streetName: 'Red Route',
        stopName: 'Kingston Quay',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.2774322',
        stopLon: '103.8554115',
        busTerminal: false,
      },
      {
        stopCode: 'RS2',
        streetName: 'Red Route',
        stopName: 'Chester Chase',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.293306',
        stopLon: '103.852408',
        busTerminal: false,
      },
      {
        stopCode: 'RS3',
        streetName: 'Red Route',
        stopName: 'Greenwich Grove',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.3029758',
        stopLon: '103.8319635',
        busTerminal: false,
      },
      {
        stopCode: 'RS4',
        streetName: 'Red Route',
        stopName: 'Hastings Harbor',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.3225964',
        stopLon: '103.8150076',
        busTerminal: false,
      },
      {
        stopCode: 'RS5',
        streetName: 'Red Route',
        stopName: 'Preston Plaza',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.340900',
        stopLon: '103.775838',
        busTerminal: false,
      },
      {
        stopCode: 'RS6',
        streetName: 'Red Route',
        stopName: 'Victoria Vault',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.363013',
        stopLon: '103.767414',
        busTerminal: false,
      },
      {
        stopCode: 'RS7',
        streetName: 'Red Route',
        stopName: 'Lancaster Loop',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: '1.425144',
        stopLon: '103.761060',
        busTerminal: false,
      },
    ],
  },
  {
    streetName: '191',
    routeId: '191',
    stops: [
      {
        stopCode: '11379',
        streetName: '191',
        stopName: 'Buona Vista Ter',
        mrtStationCode: '',
        mrtStationName: '',
        stopLat: 1.3094553354435874,
        stopLon: 103.79227925698439,
        busTerminal: true,
      },
      {
        streetName: '191',
        stopCode: '11381',
        stopName: 'Blk 10a',
        stopLat: 1.30841137865065,
        stopLon: 103.79328294102335,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '11181',
        stopName: 'Opp Blk 43',
        stopLat: 1.30722333300814,
        stopLon: 103.79227638896938,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '11369',
        stopName: 'Buona Vista Stn Exit D',
        stopLat: 1.3063259638605,
        stopLon: 103.79084827741467,
        busTerminal: false,
        mrtStationCode: "'EW21, CC22'",
        mrtStationName: 'Buona Vista',
      },
      {
        streetName: '191',
        stopCode: '18149',
        stopName: 'Essec Business Sch',
        stopLat: 1.3025599,
        stopLon: 103.7871318,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '18151',
        stopName: 'Opp One-north Stn/galaxis',
        stopLat: 1.30051083054497,
        stopLon: 103.78864286195989,
        busTerminal: false,
        mrtStationCode: "'CC23'",
        mrtStationName: 'One-North',
      },
      {
        streetName: '191',
        stopCode: '18171',
        stopName: 'Bef Weyhill Cl',
        stopLat: 1.29905478616662,
        stopLon: 103.79412910351343,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '18181',
        stopName: 'Opp Tanglin Trust Sch',
        stopLat: 1.29714585347396,
        stopLon: 103.79369361976173,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '18191',
        stopName: 'Bef Whitchurch Rd',
        stopLat: 1.294355018201415,
        stopLon: 103.7958988694358,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '18211',
        stopName: 'Infinite Studios',
        stopLat: 1.29161816867907,
        stopLon: 103.79522263706237,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '18201',
        stopName: 'Mediacorp Campus',
        stopLat: 1.29498098725808,
        stopLon: 103.7932287526945,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '18199',
        stopName: 'Aft Whitchurch Rd',
        stopLat: 1.29544342826531,
        stopLon: 103.79407617440387,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '18189',
        stopName: 'Tanglin Trust Sch',
        stopLat: 1.29839662957663,
        stopLon: 103.79390316193482,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '18179',
        stopName: 'Opp Weyhill Cl',
        stopLat: 1.29988107543841,
        stopLon: 103.79304547568137,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '18159',
        stopName: 'One-north Stn/galaxis',
        stopLat: 1.3003468994065,
        stopLon: 103.78858368998314,
        busTerminal: false,
        mrtStationCode: 'CC23',
        mrtStationName: 'One-North',
      },
      {
        streetName: '191',
        stopCode: '18141',
        stopName: 'Aft Anglo-chinese Jc',
        stopLat: 1.3040943,
        stopLon: 103.7879458,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '11361',
        stopName: 'Buona Vista Stn Exit C',
        stopLat: 1.30649698638726,
        stopLon: 103.79058123542397,
        busTerminal: false,
        mrtStationCode: "'EW21, CC22'",
        mrtStationName: 'Buona Vista',
      },
      {
        streetName: '191',
        stopCode: '11189',
        stopName: 'Blk 43',
        stopLat: 1.3073284,
        stopLon: 103.7924948,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
      {
        streetName: '191',
        stopCode: '11389',
        stopName: 'Blk 46',
        stopLat: 1.309086,
        stopLon: 103.7930101,
        busTerminal: false,
        mrtStationCode: '',
        mrtStationName: '',
      },
    ],
  },
];
